<template>
  <div class="container">
    <div v-for="item in sidebarList" :key="item.name">
      <!-- 二级菜单 -->
      <div class="level-one">
        <div class="menu-img">
          <img :src="levelTwoRouterIconList[item.meta.id] ? levelTwoRouterIconList[item.meta.id].url : '@/assets/image/menu/levelOne/outward.png'" alt="outward">
        </div>
        <span class="menu-text">{{ $t(item.meta.title)}}</span>
      </div>
      <!-- 三级菜单 -->
      <ul class="level-two" v-if="item.children && item.children.length">
        <li
          class="level-two-item"
          :class="activeLevelThreeId === child.meta.id ? 'active' : ''"
          v-for="child in item.children"
          :key="child.name"
          @click="handleClick(child)">
          {{ $t(child.meta.title) }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { levelTwoRouterIconList } from '@/utils/enum/index'
export default {
  data () {
    return {
      levelTwoRouterIconList
    }
  },
  computed: {
    ...mapState('nav', ['sidebarList', 'activeLevelThreeId'])
  },
  methods: {
    ...mapMutations('nav', ['SET_ALL']),
    handleClick (child) {
      const { meta: { id: activeLevelThreeId }, name } = child
      // 设置当前点击id
      this.SET_ALL({
        activeLevelThreeId
      })
      // 路由跳转
      this.$router.push({
        name
      })
    }
  }
}
</script>

<style scoped lang="less">
.container {
  width: 240px;
  min-height: 755px;
  background: #FFFFFF;
  border-radius: 4px;
  padding-top: 20px;
  .level-one {
    display: flex;
    align-items: center;
    margin-bottom: 7px;
    user-select: none;
    .menu-img {
      width: 40px;
      height: 40px;
      margin: 9px 10px;
      > img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .menu-text {
      font-size: 16px;
      color: #333752;
      line-height: 22px;
    }
  }
  .level-two {
    margin: 0 20px;
    width: 200px;
    background: #F6F7FC;
    border-radius: 4px;
    padding: 35px 40px;
    user-select: none;
    .level-two-item {
      position: relative;
      max-width: 120px;
      font-size: 14px;
      // font-weight: 300;
      color: #333752;
      line-height: 14px;
      margin-bottom: 35px;
      cursor: pointer;
      &::before {
        position: absolute;
        top: 50%;
        left: -21px;
        transform: translateY(-50%);
        content: '';
        width: 6px;
        height: 6px;
        border-radius: 6px;
        background: #D7DBEC;
      }
      &:last-child {
        margin-bottom: 0;
      }
      &.active {
        color: #4A6AFF;
        &::before {
          background: #4A6AFF;
        }
      }
      &:hover {
        color: #4A6AFF;
      }
    }
  }
}
</style>
